import { useNavigation } from "@react-navigation/native";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { LayoutNodeInput } from "@towersystems/roam-common/lib/generated-types";
import { useCallback, useState } from "react";
import { RegisterRootParamList } from "../../../../types";
import { DragDropActionTypes } from "../../../../utilities/drag-drop";
import { useFlashMessages } from "@towersystems/roam-common-native";
import {
  CreateQuickKeyPrerequisites,
  useLayoutEditController,
} from "../../../../utilities/layout";
import { CreateTileContext } from "../../../../utilities/layout/context";

export type CreateTileProviderProps = Partial<
  NativeStackScreenProps<RegisterRootParamList, "CreateQuickKeyRootScreen">
> & {
  children?: React.ReactNode;
};

export function CreateTileProvider({ children }: CreateTileProviderProps) {
  const navigation = useNavigation<CreateTileProviderProps["navigation"]>();
  const { showMessage } = useFlashMessages();
  const performLayoutAction = useLayoutEditController();

  const [config, setConfig] = useState<CreateQuickKeyPrerequisites | null>(
    null
  );

  const openCreateTile = useCallback(
    (nodeConfig: CreateQuickKeyPrerequisites) => {
      setConfig(nodeConfig);
      navigation?.navigate("CreateQuickKeyRootScreen");
    },
    []
  );

  async function handleCreateTile(input: LayoutNodeInput) {
    return performLayoutAction({
      type: DragDropActionTypes.CREATE_POS_LAYOUT_KEY,
      payload: {
        ...config,
        ...input,
      },
    })
      .then(() => {
        navigation?.navigate("SellScreen");
        showMessage({
          message: "Successfully Created Tile",
          severity: "success",
        });
      })
      .catch((e) => {
        showMessage({ message: e?.toString(), severity: "error" });
      });
  }

  return (
    <CreateTileContext.Provider
      value={{
        config,
        openCreateTile,
        handleCreateTile,
      }}
    >
      {children}
    </CreateTileContext.Provider>
  );
}
